import { dataProps, 
        itemListProps } from './properties'

export const setProductionOutsourceList = (state, payload) => {
    state.list = payload.response

    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
}    

export const setProductionOutsourceData = (state, payload) => {
    state.props = payload.response
} 

export const setProductionOutsourceDataItemList = (state, payload) => {

    state.props.item_list = payload
    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }
    
    let key = 0
    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })
} 

export const addNewProductionOutsourceItemListRow = state => {

    let key = 0
    state.props.item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('item_id_'+(key-1)).focus()
    }, 300);

}

export const removeProductionOutsourceItemListRow = (state, payload) => {

    let key = 0

    state.props.item_list.splice(payload, 1)

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetProductionOutsourceItemListKey = state => {

    let key = 0
    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetProductionOutsourceData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/productionOutsource/mutations.js